import { render, staticRenderFns } from "./DashboardKey.vue?vue&type=template&id=451113ea&"
import script from "./DashboardKey.vue?vue&type=script&lang=js&"
export * from "./DashboardKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451113ea')) {
      api.createRecord('451113ea', component.options)
    } else {
      api.reload('451113ea', component.options)
    }
    module.hot.accept("./DashboardKey.vue?vue&type=template&id=451113ea&", function () {
      api.rerender('451113ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/DashboardKey.vue"
export default component.exports